import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import CheckIdentityPage from './CheckIdentityPage';
import { redirectToIDVQuestionPage } from '../../store/dataCapture';

class CheckIdentitySection extends Component {
  render() {
    const { bankId, brandId, offer, redirectToIDVQuestionPage } = this.props;

    return (
      <CheckIdentityPage
        brandId={brandId}
        bankId={bankId}
        offer={offer}
        saveCheckIdentityForm={redirectToIDVQuestionPage}
      />
    );
  }
}

CheckIdentitySection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveCheckIdentityForm: PropTypes.func.isRequired
};

const actionCreators = {
  redirectToIDVQuestionPage
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckIdentitySection);
